import React, { useEffect, useState, } from "react";
import { Modal, Button,  } from 'antd';
import notification from '../../../services/notification';
import { PlusSquare, UserPlus, X, } from "@phosphor-icons/react";
import { FormattedMessage, useIntl, } from "react-intl";
import { useForm, } from "react-hook-form";
import { CustomerAdd, } from '../../../services/customer';
import { CustomerSettings, } from '../../../services/settings';
import { GetCustomerUsergroups, } from '../../../services/users';
import CustomerFormView from './views/customer.form.view';

const CustomerAddModal = ({
    modalIsOpen,
    modalIsOpenHandler,
    refreshData,
    history,
    ...props
}) => {

    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [resetCustomerFieldsData, setResetCustomerFieldsData] = useState([]);
    const [userGroups, setUserGroups] = useState(undefined);
    const { handleSubmit, control, watch, reset, } = useForm({ defaultValues: { customer_type: "CONSUMER" } });
    const intl = useIntl();
    const customerType = watch("customer_type");

    useEffect(() => {
        GetCustomerSettings();
        getUsergroups();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (resetCustomerFieldsData) {
            reset({
                customfields: resetCustomerFieldsData,
                customer_type: "CONSUMER",
                country: "nl",
                send_welcome_mail: false,
            });
        }
        // eslint-disable-next-line
    }, [resetCustomerFieldsData]);

    const onSubmit = (data) => {
        setButtonDisabled(true);

        const postdata = {
            customer_type: customerType,
            agree_privacy_statement: false,
            agree_terms: false,
            agree_mailling_list: false,
            ...data
        };
        postdata.customer_name = (customerType === "COMPANY" || customerType === "DEALER") ? data.customer_name : `${data.customer_firstname} ${data.customer_lastname}`;


        CustomerAdd(postdata, history)
            .then(response => {
                if (response.status) {
                    notification['success']({
                        message: 'Update',
                        description: intl.formatMessage({ id: response.msg }),
                    });

                    //close modal
                    history(`/customer/details/${response.data.customer_id}`);
                    modalIsOpenHandler(false);
                } else {
                    notification['error']({
                        message: 'Update',
                        description: intl.formatMessage({ id: response.msg }),
                    });
                    setButtonDisabled(false);
                }
            })
            .catch(error => {
                console.warn('error: ', error);
                notification['error']({
                    message: 'Account',
                    description: intl.formatMessage({ id: "UNKNOW_ERROR" }),
                });
                setButtonDisabled(false);
            });
    };

    const GetCustomerSettings = () => {
        CustomerSettings('me', history)
            .then(response => {

                // setup the custom fields
                var tmp_custom_fields = [];
                const custom_fields = response.data.customer_settings.customer_custom_fields;

                for (let index = 0; index < custom_fields?.length; index++) {
                    const element = custom_fields[index];

                    tmp_custom_fields[index] = {
                        [`${element.field_id}`]: '',
                        data: element,
                    }
                }

                setResetCustomerFieldsData(tmp_custom_fields.filter(Boolean));
            })
            .catch(error => { });
    };

    const getUsergroups = () => {
        GetCustomerUsergroups('me', history)
            .then(response => {
                if (response.status) {
                    var tmp = [];
                    for (let i = 0; i < response.data.user_groups.length; i++) {
                        tmp.push({
                            value: response.data.user_groups[i].ug_id,
                            label: response.data.user_groups[i].ug_name
                        });
                    }

                    setUserGroups(tmp);
                }
            })
            .catch(error => { });
    };

    return (

        <Modal
            open={modalIsOpen}
            title={<><UserPlus size={18} weight="light" className="mr-1" /> <FormattedMessage id="customer-add" /></>}
            onCancel={() => modalIsOpenHandler(false)}
            width={750}
            footer={[
                <Button key="1" onClick={() => modalIsOpenHandler(false)}
                    icon={<X size={16} />}>
                    <FormattedMessage id="cancel" />
                </Button>,
                <Button key="2"
                    className="ant-btn-success"
                    loading={buttonDisabled}
                    onClick={handleSubmit(onSubmit)}
                    icon={!buttonDisabled && (<PlusSquare size={16} weight="light" />)}>
                    <FormattedMessage id="add" />
                </Button>,
            ]}>

            <CustomerFormView
                history={history}
                control={control}
                watch={watch}
                editMode="add"
                userGroups={userGroups}
                {...props}
            />

        </Modal>
    );
};

export default CustomerAddModal;